import { useQuery } from '@tanstack/react-query';
import { translateText } from './api-requests';
import _ from 'lodash';
import { queryProperties } from '@lib/utils';

export const useTranslation = (sourceText, targetLanguageCode) => {
  /** This handles the case when we have a <LocalTranslatedText>
   *  which is wrapping around another <LocalTranslatedText>
   *  This is a bit of a hack but just here until we fully
   *  rewrite this code.
   **/
  if (_.isObject(sourceText)) {
    if (_.isString(sourceText?.props?.children)) {
      sourceText = sourceText.props.children;
    } else if (_.isString(sourceText?.props?.text)) {
      sourceText = sourceText.props.text;
    } else {
      throw new Error('useTranslation: sourceText is an object. ');
    }
  }

  const cleanedText = (sourceText ?? '').trim();
  const cleanedLang = targetLanguageCode?.toLowerCase();

  const enabled = !!cleanedText && !!cleanedLang && cleanedLang !== 'en';

  return useQuery({
    queryKey: ['translation', cleanedText, cleanedLang],
    queryFn: async () => {
      return await translateText(cleanedText, cleanedLang);
    },
    enabled,
    ...queryProperties,
    staleTime: 1000 * 60 * 30, // 30 minutes
  });
};
